import { useEffect, useRef, useState } from 'react';

// Keeps a "show the loader" flag true for at least `minMs` once it turns
// true, even if the underlying request finishes sooner — avoids a
// one-frame spinner flash on fast responses. Does not delay the moment
// loading starts, only the moment it's allowed to hide.
export default function useMinLoading(loading, minMs = 2000) {
  const [visible, setVisible] = useState(loading);
  const shownAt = useRef(loading ? Date.now() : null);

  useEffect(() => {
    if (loading) {
      shownAt.current = Date.now();
      setVisible(true);
      return;
    }

    if (shownAt.current == null) {
      setVisible(false);
      return;
    }

    const remaining = minMs - (Date.now() - shownAt.current);

    if (remaining <= 0) {
      shownAt.current = null;
      setVisible(false);
      return;
    }

    const timer = setTimeout(() => {
      shownAt.current = null;
      setVisible(false);
    }, remaining);

    return () => clearTimeout(timer);
  }, [loading, minMs]);

  return visible;
}
